import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert, Spin } from 'antd';
import { Router } from 'src/routes';
import AuthStorage from 'src/utils/AuthStorage';
import { getMaintenanceMode } from 'src/redux/actions/maintenanceMode';

const mapStateToProps = state => ({
	store: {
		maintenanceMode: state.maintenanceMode
	}
});

const mapDispatchToProps = dispatch => ({
	action: bindActionCreators(
		{
			getMaintenanceMode
		},
		dispatch
	)
});

@connect(
	mapStateToProps,
	mapDispatchToProps
)
export default class MaintenanceModeGuard extends PureComponent {
	static propTypes = {
		children: PropTypes.node.isRequired,
		store: PropTypes.shape({
			maintenanceMode: PropTypes.object.isRequired
		}),
		action: PropTypes.shape({
			getMaintenanceMode: PropTypes.func.isRequired
		})
	};

	state = {};

	componentDidMount() {
		// Only check maintenance mode for authenticated users
		// Skip check for login page
		if (AuthStorage.loggedIn && Router.pathname !== '/login') {
			this.checkMaintenanceMode();
		}
	}


	componentDidUpdate(prevProps) {
		// Re-check maintenance mode when user logs in
		const prevUserId = prevProps.store && prevProps.store.auth && prevProps.store.auth.userId;
		const currentUserId = this.props.store && this.props.store.auth && this.props.store.auth.userId;
		
		if (!prevUserId && currentUserId && AuthStorage.loggedIn && Router.pathname !== '/login') {
			this.checkMaintenanceMode();
		}
	}

	checkMaintenanceMode = () => {
		const { action } = this.props;
		
		action.getMaintenanceMode(
			{},
			(response) => {
				// If maintenance mode is enabled, redirect to login with message
				if (response === true) {
					// Only allow ROLE_TAMAA users to access during maintenance
					if (!AuthStorage.isTama) {
						// Clear auth and redirect to login
						AuthStorage.destroy();
						Router.pushRoute('/login?maintenance=true');
					}
				}
			},
			(error) => {
				// On error, allow access to prevent blocking users
				console.warn('Maintenance mode check failed, allowing access:', error);
			}
		);
	};

	render() {
		const { children, store } = this.props;
		const { isMaintenanceMode } = store.maintenanceMode;

		// No loading screen - check happens silently in background

		// If maintenance mode is active and user is not ROLE_TAMAA, show maintenance message
		if (isMaintenanceMode && AuthStorage.loggedIn && !AuthStorage.isTama && Router.pathname !== '/login') {
			return (
				<div style={{ 
					display: 'flex', 
					justifyContent: 'center', 
					alignItems: 'center', 
					minHeight: '100vh',
					flexDirection: 'column',
					padding: '20px'
				}}>
					<Alert
						message="Maintenance en cours"
						description="L'application est temporairement en maintenance. Veuillez nous excuser pour la gêne occasionnée."
						type="warning"
						showIcon
						style={{ maxWidth: '500px', marginBottom: '20px' }}
					/>
					<button 
						onClick={() => {
							AuthStorage.destroy();
							Router.pushRoute('/login');
						}}
						style={{
							padding: '8px 16px',
							color: 'white',
							border: 'none',
							borderRadius: '4px',
							cursor: 'pointer'
						}}
						className='ant-btn-primary'
					>
						Retour à la connexion
					</button>
				</div>
			);
		}

		return children;
	}
}
